module.exports = __webpack_public_path__ + "static/media/unionpay.1f53e6c7.png";